import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { requestAppTracking } from "@/lib/appTracking";

// iOS only (no-op elsewhere). SAFETY NET for installs made before the Welcome screen asked ATT
// (pages/Welcome.jsx): first time a signed-in member reaches the feed. Idempotent (iOS answers
// once per install) and queued → never overlaps the push-permission or UMP consent dialogs.
export const AppTrackingGate = () => {
  const { user } = useApp();
  const { pathname } = useLocation();
  useEffect(() => {
    if (user && pathname === "/home") requestAppTracking();
  }, [user, pathname]);
  return null;
};
